import { app } from '../../../bootstrap/core';
import { acceptableAccordionComponent } from './acceptableAccordion.component';
import './section/acceptableAccordionSection';

app.component('acceptableAccordion', acceptableAccordionComponent);
